import React from 'react';

const TechDeepDive = () => {
  return (
    <section id="tech-deep-dive" className="tech-deep-dive-section">
      <div className="tech-deep-dive-container">
        <div className="section-header">
          <h2 className="section-title">Tech Deep Dive</h2>
          <p className="section-subtitle">
            How I approach frontend development
          </p>
        </div>

        <div className="tech-dive-grid">
          <div className="tech-dive-card">
            <h3 className="tech-dive-title">API Integration & Data Fetching</h3>
            <p className="tech-dive-content">
              I use React Query for server state management, custom hooks for API abstraction, 
              and error boundary patterns for resilient data fetching. Focus on request 
              deduplication, caching strategies, and optimistic updates that provide seamless 
              user experiences with minimal loading states.
            </p>
          </div>

          <div className="tech-dive-card">
            <h3 className="tech-dive-title">React Architecture Style</h3>
            <p className="tech-dive-content">
              I follow Container-Presenter pattern separation, custom hooks for 
              reusable logic, and modular component structure. Each component has 
              a single responsibility, making codebase maintainable and testable 
              at scale.
            </p>
          </div>

          <div className="tech-dive-card">
            <h3 className="tech-dive-title">How I Build Scalable Frontend Apps</h3>
            <p className="tech-dive-content">
              Clear folder structure with feature-based organization, reusable 
              component library, performance-first mindset with monitoring. 
              Emphasis on type safety, testing, and documentation for long-term 
              maintainability.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechDeepDive;

